import { FC, useState } from "react";
import { useSelector } from "react-redux";
import { IClassTestInfo, ITestStudent } from "../../../models/tutor.model";
import { RootState } from "../../../store/rootReducer";
import ClassTest from "./ClassTest";
import TestScore from "./TestScore";

interface IProps {
  tab: string;
  setTab: (tab: string) => void;
}

const TestContainer: FC<IProps> = ({
  tab,
  setTab,
}) => {
  const { chosenClass } = useSelector((state: RootState) => state.class);

  const [testRecord, setTestRecord] = useState<IClassTestInfo>();
  const [studentRecord, setStudentRecord] = useState<ITestStudent>();

  const renderTabContent = () => {
    switch (tab) {
      case 'test':
        return (
          <ClassTest
            setTab={setTab}
            testRecord={testRecord}
            setTestRecord={setTestRecord}
            setStudentRecord={setStudentRecord}
            classCode={chosenClass?.classCode}
          />
        );
      case 'testScore':
        return (
          <TestScore
            setTab={setTab}
            testRecord={testRecord}
            studentRecord={studentRecord}
          />
        );
      default:
        return null;
    }
  }

  return renderTabContent();
}

export default TestContainer;
